import { createClass as _createClass, typeof as _typeof, slicedToArray as _slicedToArray, classCallCheck as _classCallCheck } from '../_virtual/_rollupPluginBabelHelpers.js';
import { isValid, formatISO } from 'date-fns';
import isEqual from 'lodash/isEqual';
var JsonApiRecordDecorator = /*#__PURE__*/function () {
  function JsonApiRecordDecorator() {
    _classCallCheck(this, JsonApiRecordDecorator);
  }
  return _createClass(JsonApiRecordDecorator, [{
    key: "unwrap",
    value: function unwrap() {
      var attributes = Object.assign({}, this);
      delete attributes.id;
      delete attributes.type;
      delete attributes._original;
      return {
        id: this.id,
        type: this.type,
        attributes: attributes
      };
    }
  }, {
    key: "getMeta",
    value: function getMeta() {
      return this._original.meta;
    }
  }, {
    key: "standardizeValue",
    value: function standardizeValue(currVal) {
      var date = new Date(currVal);
      switch (true) {
        case Array.isArray(currVal):
          return currVal.slice(0).sort();
        case ['object', 'boolean'].includes(_typeof(currVal)):
          return currVal;
        case currVal === 'true':
          return true;
        case currVal === 'false':
          return false;
        case currVal === '':
          return null;
        case !isNaN(currVal):
          return Number(currVal);
        case isValid(date):
          return formatISO(date);
        default:
          return currVal;
      }
    }
  }, {
    key: "isDirty",
    get: function get() {
      var _this = this;
      if (this._original) {
        return Object.entries(this._original.attributes).some(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            origValue = _ref2[1];
          var origVal = _this.standardizeValue(origValue);
          var currVal = _this.standardizeValue(_this[key]);
          return !isEqual(currVal, origVal);
        });
      } else {
        return Object.entries(this).some(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];
          // type will always be set, but that doesn't make a new object dirty
          if (key === 'type') {
            return false;
          } else {
            return Array.isArray(value) ? !!value.length : !!value;
          }
        });
      }
    }
  }]);
}();
export { JsonApiRecordDecorator };